import { useIntl } from 'react-intl';
import { NumberField, Spacer, TextAreaField, TextField } from '@skf-internal/ui-components-react-legacy';
import DesignationComboBox, { DesignationItem } from 'features/search/DesignationComboBox';
import { useAppSelector } from 'store';
import { ObjectType } from 'domain/shared/ObjectId';
import { RelationGenerator } from 'domain/index';

const GeneratorForm = ({ generator, onFormChange: onPartChange, formError }: Props) => {
  const intl = useIntl();

  const generatorChanges = useAppSelector((state) => state.changesetDetailsData.changesetDetails?.refs.filter((ref) => ref.type === ObjectType.GENERATOR));
  const additionalItems = generatorChanges?.map(
    (change) =>
      ({
        id: change.id,
        name: change.name,
        manufacturerName: '-'
      } as DesignationItem)
  );

  const onGeneratorChange = (item: DesignationItem | null) => {
    if (item) {
      onPartChange({
        ...generator,
        objectId: item.id,
        generatorName: item.name,
        manufacturer: { manufacturerName: item.manufacturerName },
        generator: {
          generatorName: item.name,
          manufacturer: { manufacturerName: item.manufacturerName }
        }
      });
    } else {
      onPartChange({
        ...generator,
        objectId: null,
        generatorName: null,
        manufacturer: null,
        generator: {
          generatorName: null,
          manufacturer: { manufacturerName: null }
        }
      });
    }
  };
  const onManufacturerChange = (event: any, value: string) => {};
  const onMarketShareChange = (event: any, value: number) => {
    onPartChange({ ...generator, marketShare: value });
  };
  const onRemarkChange = (event: any, value: string) => {
    onPartChange({ ...generator, remark: value });
  };
  const getSeverity = (fieldName: string): 'error' | 'info' | 'success' | 'warning' | undefined => {
    if (formError && formError.get(fieldName)) {
      return 'error';
    }
  };
  const getHint = (fieldName: string): string | undefined => {
    if (formError && formError.get(fieldName)) {
      return formError.get(fieldName);
    }
  };

  return (
    <div className="flex flex-wrap">
      <div className="w-1/2 pl-2 pr-2">
        <DesignationComboBox
          label={intl.formatMessage({ id: 'entity.category.generator' })}
          value={generator.objectId ? { id: generator.objectId, name: generator.generator?.generatorName ?? '', manufacturerName: generator.generator?.manufacturer.manufacturerName ?? '' } : undefined}
          recordCategory={ObjectType.GENERATOR}
          onChange={onGeneratorChange}
          additionalItems={additionalItems}
          severity={getSeverity('objectId')}
          hint={getHint('objectId')}
        />
        <Spacer />
      </div>
      <div className="w-1/2 pl-2 pr-2">
        <TextField disabled onChange={onManufacturerChange} value={generator.generator?.manufacturer.manufacturerName ?? ''} feLabel={intl.formatMessage({ id: 'windTurbine.manufacturer' })} />
        <Spacer />
      </div>
      <div className="w-1/2 pl-2 pr-2">
        <NumberField min={0} feHint={getHint('marketShare')} feSeverity={getSeverity('marketShare')} onChange={onMarketShareChange} value={generator.marketShare} feLabel={intl.formatMessage({ id: 'windTurbine.marketShare' })} />
        <Spacer />
      </div>
      <div className="w-full pl-2 pr-2">
        <TextAreaField rows={5} onChange={onRemarkChange} value={generator.remark} feLabel={intl.formatMessage({ id: 'windTurbine.remark' })} />
        <Spacer />
      </div>
    </div>
  );
};

interface Props {
  generator: RelationGenerator;
  onFormChange: any;
  formError?: Map<string, string>;
}

export default GeneratorForm;
